"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _CopyPartResult_1 = require("./_CopyPartResult");
exports.UploadPartCopyOutput = {
    type: "structure",
    required: [],
    members: {
        CopySourceVersionId: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-copy-source-version-id"
        },
        CopyPartResult: {
            shape: _CopyPartResult_1._CopyPartResult
        },
        ServerSideEncryption: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-server-side-encryption"
        },
        SSECustomerAlgorithm: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-server-side-encryption-customer-algorithm"
        },
        SSECustomerKeyMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-server-side-encryption-customer-key-MD5"
        },
        SSEKMSKeyId: {
            shape: {
                type: "string",
                sensitive: true
            },
            location: "header",
            locationName: "x-amz-server-side-encryption-aws-kms-key-id"
        },
        RequestCharged: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-request-charged"
        }
    },
    payload: "CopyPartResult"
};
//# sourceMappingURL=UploadPartCopyOutput.js.map